{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Schermo intero",
		"achievements": "Obiettivi",
		"reset": "Azzera",
		"language": "Lingua"
	},
	"achievements": {
		"title": "Obiettivi",
		"noAchievements": "Nessun obiettivo sbloccato. Continua a cliccare!",
		"unlocked": "Obiettivo Sbloccato: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Coniglio Principiante",
		"carrotSnatcher": "🥕 Ladro di Verdure",
		"bunnyBerserker": "😡 Coniglio Furioso",
		"hopPunk": "🎸 Coniglio Anarchico",
		"bunnyNinja": "🥷 Silenzioso ma Letale",
		"expert": "🌟 Saltatore Esperto",
		"master": "👑 Re delle Carote",
		"carrotpocalypse": "🥕 Distruttore di Orti",
		"bunnyOverlord": "😈 Signore Supremo della Tana",
		"chaosHare": "🌪️ Agente del Caos",
		"carrotCultist": "⛪ Sommo Sacerdote del Culto della Carota",
		"bunnyberryPie": "🥧 Maestro della Torta Allucinogena",
		"rabbitHole": "🕳️ Scavatore di Tunnel Quantici",
		"moonRabbit": "🌙 Coniglio Lunare",
		"bunnyDoom": "💀 Araldo del Coniglipocalisse",
		"carrotNuke": "☢️ Portatore della Carota Nucleare",
		"bunnyMatrix": "🤖 Glitch nella Matrice dei Conigli",
		"cosmicHare": "🌌 La Lepre Cosmica Si Risveglia",
		"warrenSingularity": "🕳️ Singolarità della Tana Raggiunta",
		"eternalBunny": "♾️ Il Coniglio Eterno"
	},
	"messages": {
		"prophecy": "L'antica profezia del click inizia a svelarsi...",
		"cosmic": "I cliccatori cosmici sarebbero fieri del tuo progresso!",
		"astral": "I click echeggiano attraverso il piano astrale...",
		"speaking": "Aspetta... hai sentito? I click mi stanno parlando...",
		"ancient": "Il tuo clicking risuona con potere antico!",
		"sages": "I Saggi del Click sussurrano del tuo potenziale...",
		"demons": "CONTEMPLA! I Demoni del Click si risvegliano dal loro sonno!",
		"veil": "I tuoi click trafiggono il velo della realtà!",
		"spirits": "Gli Spiriti del Click danzano al tuo ritmo...",
		"council": "Il Gran Consiglio del Click ha notato la tua dedizione",
		"primordial": "Il tuo clicking risveglia forze primordiali!",
		"void": "Il vuoto del clicking ti fissa negli occhi...",
		"runes": "Le antiche rune del click brillano col tuo potere!",
		"beast": "TRE TRE TRE - IL NUMERO DELLA BESTIA DEL CLICK",
		"prophets": "I Profeti del Click cantano del tuo arrivo!",
		"dimensions": "I tuoi click echeggiano attraverso le dimensioni...",
		"portal": "I tuoi click hanno aperto un portale verso la Dimensione del Click!",
		"sacrifice": "Gli antichi Dei del Click esigono PIÙ SACRIFICI",
		"jackpot": "JACKPOT! Il Casinò del Click dà il benvenuto al suo nuovo campione!",
		"unmatched": "Il tuo potere di click è imbattibile!",
		"reality": "La realtà stessa si piega alla tua volontà di clicking!",
		"elite": "SEI DIVENTATO IL MAESTRO CLICK D'ELITE",
		"power": "Il tuo livello di potere click supera 1500!",
		"devils": "I Diavoli del Click si inchinano al tuo potere",
		"lucky": "I click fortunati scorrono nelle tue vene",
		"dynasty": "La Dinastia del Click riconosce la tua supremazia",
		"twoThousand": "Duemila click di puro potere!",
		"quartet": "La profezia del Quartetto del Click si è avverata",
		"transcend": "Il tuo clicking trascende la comprensione mortale",
		"constellation": "La Costellazione del Click si allinea in tuo onore",
		"destiny": "TREMILA CLICK DEL DESTINO",
		"triforce": "La Triforza Tripla del Click si risveglia!",
		"fortune": "La fortuna favorisce il cliccatore persistente",
		"newDimensions": "Il tuo potere di click raggiunge nuove dimensioni",
		"quartet2": "Il Quartetto Quadruplo del Click armonizza",
		"threshold": "In piedi sulla soglia della divinità del click",
		"ultimate": "CINQUEMILA CLICK DI POTERE SUPREMO!",
		"force": "La Forza Click delle Cinque Dita è ai tuoi comandi",
		"underworld": "Il Sottomondo del Click ti incorona loro sovrano",
		"maxJackpot": "RAGGIUNTO IL JACKPOT MASSIMO DEI CLICK",
		"infinite": "POTERE DI CLICK INFINITO!",
		"godhood": "SEI ASCESO ALLA DIVINITÀ DEL CLICK",
		"burrow": "Hai scavato più in profondità di qualsiasi coniglio prima di te...",
		"warren": "La Grande Tana riconosce la tua presenza...",
		"thump": "La terra trema ad ogni colpo della tua zampa!",
		"darkWarren": "La Tana Oscura apre i suoi cancelli per te...",
		"ears": "Le tue orecchie si allungano... ora puoi sentire tutto...",
		"carrotThrone": "Il Trono di Carota si materializza davanti a te...",
		"onesAlignment": "Tutti gli uni si allineano - la Frequenza della Tana risuona!",
		"moonSummon": "Il Coniglio Lunare sente la tua chiamata attraverso il vuoto...",
		"edgeOfForever": "Sei al bordo dell'eternità... orecchie tremanti...",
		"beyondTheVeil": "Oltre il velo, tutte le tane diventano una...",
		"sequence": "1-2-3-4-5... La Sacra Sequenza del Salto è completa!",
		"hyperElite": "STATO IPER ELITE SBLOCCATO 🐇🐇🐇",
		"eventHorizon": "Oltre l'orizzonte degli eventi della Tana Cosmica...",
		"matrixAwakens": "La Matrice della Tana ha un glitch... vedi le carote dietro la realtà",
		"luckyForever": "Ogni zampa, ogni salto, ogni fremito... benedetto per sempre",
		"twentyK": "VENTIMILA. Non sei più un coniglio. Sei IL coniglio.",
		"singularity": "La Singolarità dei Conigli. Tutti i conigli sei tu. Tu sei tutti i conigli.",
		"tripleAscension": "La Tripla Ascensione della Lepre Cosmica!",
		"ultimateAnswer": "42.000 - La Risposta Definitiva sono sempre state le carote",
		"eternity": "♾️ LA TANA ETERNA NON HA FINE. NEANCHE TU. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Punti Bonus!",
		"clickStreak": "🔥 {{count}} Click Consecutivi!",
		"fire": "🔥 Potere di Fuoco Attivato!"
	},
	"table": {
		"achievement": "Obiettivo",
		"progress": "Progresso"
	},
	"reset": {
		"confirm": "Sei sicuro di voler azzerare tutti i progressi? Questa azione non può essere annullata."
	}
}
